import React from "react";
import styles from "./payment-method-transaction-filter.module.scss";
import { Field, Button, Title } from "components/commons";
import { locale } from "localization/en";
import SearchTypeField from "components/commons/search-field/search-type";

const PaymentMethodTransactionFilter = ({
  title,
  filterState,
  modifyFilter,
  searchKey,
  modifySearch,
  applySearch,
  applyClearSearch,
  exportReport,
  exporting,
}) => {
  const searchType = [
    { label: locale.referenceNo, value: "refNumber" },
    { label: locale.transactionNo, value: "transactionNo" },
  ];

  return (
    <div className={styles?.container}>
      <div className={styles?.filter}>
        <div className={styles?.title}>
          <Title small black={true}>
            {title}
          </Title>
        </div>
        <Field className={styles.search}>
          <SearchTypeField
            placeholder={locale.keyword}
            value={searchKey}
            searchWithSymbols={false}
            restrict={false}
            onChange={(_, { value }) => {
              modifySearch(value);
            }}
            onEnter={applySearch}
            onClear={applyClearSearch}
            searchKeyName={"searchType"}
            searchKeyValue={filterState.searchType}
            searchKeyOptions={searchType}
            searchKeyOnChange={(name, { value }) => {
              modifyFilter({ [name]: value });
            }}
          />
        </Field>
        <Field className={styles.downloadButton}>
          <Button
            startIcon={<span className="icon-download" />}
            exportButton
            onClick={() => exportReport({})}
            disabled={exporting}
            loading={exporting}
          >
            {locale.export}
          </Button>
        </Field>
      </div>
    </div>
  );
};

export default PaymentMethodTransactionFilter;
